module.exports = __webpack_public_path__ + "img/手机拖拽旋转.d56766a8.png";